import { useState, useMemo, useEffect } from 'react';
import { useAuth } from '../../utils/Auth';
import { AnimatePresence, motion } from 'motion/react';
import { transition, variants } from './variants';
import { useParams, useNavigate } from 'react-router-dom';
import { useAssetQR } from '../../utils/hooks/useAssetQR';
import { handleTextWithLinks } from '../../utils/QRFunctions/handleTextWithLinks';
import AssetCarousel from '../../components/AssetComponents/AssetCarousel';
import AssetTracker from '../../components/AssetComponents/AssetTracker';
import styles from './AssetPage.module.css';

export default function AssetPage() {
    const { activeOrgId } = useAuth();
    const navigate = useNavigate();
    const { id } = useParams();

    const [ assets, qr ] = useAssetQR(id)
    const [ edit, setEdit ] = useState(false);

    useEffect(() => {
        if (edit === true) {
            if (id) {
                navigate(`/collection/${id}/edit?ref=${encodeURI(`/a/${id}`)}&tab=configure`);
            };
        };
    },[id, edit]);

    const handleButtons = useMemo(() => {
        if (qr?.org_id === activeOrgId) {
            return (
                <>
                <button className={styles.displayName} onClick={() => navigate(`/collection`, { state: { qrID: id } })}>Collection</button>
                <button className={styles.editBtn} onClick={() => setEdit(true)} disabled={qr?.org_id !== activeOrgId} >Edit</button>
                </>
            );
        } else {
            return <div className={styles.displayName}>Liquid Label</div>
        };
    },[activeOrgId, qr?.org_id]);

    const handleReturn = useMemo(() => (
        <>
        <AssetHeader qr={qr} />
        <div className={styles.body}>
            <AssetTracker qr={qr} id={id} />
            <AssetCarousel assets={assets} />
        </div>
        </>
    ),[assets, qr]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <AnimatePresence mode='wait'>
                    <motion.div
                        key='display' 
                        className={styles.display}
                        transition={transition}
                        variants={variants}
                        initial='initial'
                        animate='animate'
                        exit='initial'
                    >
                        {handleButtons}
                        {handleReturn}
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
    );
};

const AssetHeader = ({qr}) => {
    return (
        <div className={styles.header}>
            {Object.keys(qr).length > 0 ? 
                <>
                <h2 className={styles.nickname}>{qr?.nickname}</h2>
                <div className={styles.descriptionWrap}>
                    <div className={styles.description}>{qr?.asset?.description?.length > 0 ? handleTextWithLinks(qr?.asset?.description) : <></>}</div>
                </div>
                <div className={styles.notesWrap}>
                    <div className={styles.notes}>{qr?.asset?.notes?.length > 0 ? handleTextWithLinks(qr?.asset?.notes) : <></>}</div>
                </div>
                </>
                : <div className={styles.loading}><i className='fas fa-spinner fa-spin-pulse' /></div>
            }
        </div>
    )
};